// Module
var code = "<div ng-if=\"$ctrl.notes.length\" layout=\"column\" class=\"notes-container\"> <div layout=\"column\" ng-repeat=\"note in $ctrl.notes track by $index\" ng-class=\"{'margin-top-5': !$first}\"> <span class=\"br-body-2 desc-txt\">{{note}}</span> </div> </div> ";
// Exports
export default code;